import * as React from "react";
import { type DialogOptions, type DialogTypes } from "../../Actions/Dialogs/DialogActions";
import DialogContent from "../Dialogs/DialogContent";

export interface EditPageDialogType {
    header: string;
    content: React.ReactNode;
    type: DialogTypes;
    options: Array<DialogOptions> | false;
    showFrame: boolean;
}

interface Props {
    dialog?: EditPageDialogType;
    onHide?: () => void;
}

export default class EditPageDialog extends React.Component<Props> {
    public render(): React.ReactNode {
        const { dialog, onHide } = this.props;

        const containerClasses = [ "edit-page-dialog-container" ];
        const classes = [ "edit-page-dialog" ];

        let content = null;

        if(dialog) {
            classes.push(dialog.type);
            containerClasses.push("open");

            let dialogContent;

            if(dialog.showFrame) {
                classes.push("show-frame");
                dialogContent = (
                    <DialogContent
                        header={dialog.header}
                        content={dialog.content}
                        type={dialog.type}
                        options={dialog.options}
                        onHide={onHide}
                    />
                );
            } else {
                classes.push("no-frame");
                dialogContent = dialog.content;
            }

            content = (
                <React.Fragment>
                    <div className={classes.join(" ")}>
                        {dialogContent}
                    </div>
                    <div className="edit-page-dialog-backdrop" />
                </React.Fragment>
            );
        }

        return (
            <div className={containerClasses.join(" ")}>
                {content}
            </div>
        );
    }
}
